import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=logged out, obj=logged in

  const refresh = async () => {
    const token = localStorage.getItem("jeax_token");
    if (!token) { setUser(false); return; }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      localStorage.removeItem("jeax_token");
      setUser(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("jeax_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const changePassword = async (newPassword) => {
    const { data } = await api.post("/auth/change-password", { new_password: newPassword });
    localStorage.setItem("jeax_token", data.token);
    setUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem("jeax_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, changePassword, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
